import { rerenderValidationNew, validateField } from "../utils/validation";
import { trans } from "../i18n/i18n";

// Constants
const REGISTER_FORM_SELECTOR = "#register-form";

/**
 * Initializes registration form validation.
 */
export function initRegisterFormValidation() {
    const form = document.querySelector(REGISTER_FORM_SELECTOR);
    if (!form) return;

    form.addEventListener("input", handleFormInput);
    form.addEventListener("change", handleFormInput);
}

/**
 * Validates fields on input or change events.
 *
 * @param {Event} e
 */
function handleFormInput(e) {
    const inputEl = e.target;
    const fieldName = inputEl.name;

    const allErrors = validateField(e.currentTarget, inputEl, getRegisterValidationRules(), getWhitelistRegister());
    const fieldErrors = allErrors?.[fieldName] || [];
    rerenderValidationNew(inputEl, fieldErrors);
}

/**
 * Defines validation rules for the registration form.
 *
 * @returns {Object}
 */
export function getRegisterValidationRules() {
    return {
        first_name: {
            presence: true,
            length: { minimum: 2 }
        },
        last_name: {
            presence: true,
            length: { minimum: 2 }
        },
        email: {
            presence: true,
            email: true
        },
        password: {
            presence: true,
            length: { minimum: 8 }
        },
        password_confirmation: {
            presence: true,
            equality: { attribute: "password", message: trans("Passwords do not match") }
        },
        agreed_tac: {
            presence: { message: trans("You must agree to the terms and conditions") },
            checked: true
        }
    };
}

/**
 * Defines the whitelist of fields to validate.
 *
 * @returns {Object}
 */
export function getWhitelistRegister() {
    return {
        first_name: true,
        last_name: true,
        email: true,
        password: true,
        password_confirmation: true,
        agreed_tac: true
    };
}
